"use client";

import {
  FloatingContext,
  useFloatingContext,
} from "@faire/slate/private/floating/FloatingContext";
import { FloatingAlignment } from "@faire/slate/private/floating/types";
import { ModalContext } from "@faire/slate/private/modal/ModalContext";
import { PopupRoot } from "@faire/slate/private/popup/PopupRoot";
import { useClick, useListNavigation } from "@floating-ui/react";
import React from "react";

import { MenuContext, useMenuContext } from "./MenuContext";

type IProps = {
  alignment: FloatingAlignment;
};

export const MenuRoot: React.FC<React.PropsWithChildren<IProps>> = ({
  alignment,
  children,
}) => {
  return (
    <FloatingContext>
      <MenuContext>
        <ModalContext>
          <Root alignment={alignment}>{children}</Root>
        </ModalContext>
      </MenuContext>
    </FloatingContext>
  );
};

const Root = ({ alignment, children }: React.PropsWithChildren<IProps>) => {
  const { floatingRootContext } = useFloatingContext();
  const menuContext = useMenuContext();

  const click = useClick(floatingRootContext);
  const listNavigation = useListNavigation(floatingRootContext, {
    listRef: menuContext.itemsRef,
    activeIndex: menuContext.activeIndex,
    onNavigate: menuContext.setActiveIndex,
  });

  return (
    <PopupRoot
      position="bottom"
      alignment={alignment}
      role="menu"
      interactions={[click, listNavigation]}
    >
      {children}
    </PopupRoot>
  );
};
